module.exports = __webpack_public_path__ + "img/objects-column.25fbbf90.svg";